import React from 'react';
import { X } from 'lucide-react';

interface AlertModalProps {
  open: boolean;
  title: string;
  message: string;
  variant?: 'success' | 'error' | 'info';
  confirmLabel?: string;
  onClose: () => void;
  onButton?: (payload?: any) => void;
}

const variantStyles: Record<string, string> = {
  success: 'text-green-600',
  error: 'text-red-600',
  info: 'text-blue-600',
};

const AlertModal: React.FC<AlertModalProps> = ({
  open,
  title,
  message,
  variant = 'info',
  confirmLabel = 'OK',
  onClose,
  onButton
}) => {
  if (!open) return null;

  // const showButton = confirmLabel;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 p-4">
      <div className="bg-white rounded-xl shadow-xl max-w-sm w-full p-6 relative text-center">
        <button
          type="button"
          className="absolute top-4 right-4 text-gray-400 hover:text-gray-600"
          onClick={onClose}
        >
          <X className="w-5 h-5" />
        </button>

        <h3 className={`text-lg font-semibold ${variantStyles[variant]}`}>
          {title}
        </h3>
        <p className="mt-2 text-gray-700">{message}</p>

        <button
          type="button"
          onClick={onButton || onClose}
          className="mt-6 w-full btn-primary"
        >
          {confirmLabel}
        </button>

      </div>
    </div>
  );
};

export default AlertModal;